var generateStyle = function generateStyle(componentTheme) {
  return {
    root: {
      padding: componentTheme.rootPadding,
      borderBottom: componentTheme.rootBottomBorder
    },
    pointsAndPercentage: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-around'
    },
    alertWrapper: {
      width: '100%',
      margin: "".concat(componentTheme.alertWrapperMargin, " 0")
    }
  };
};
export default generateStyle;